var PortraitsController = function() {
    this.getScrollScene = require('../module/getScrollScene');
    this.InfiniteScroll = require('../module/InfiniteScroll');
    this.init();
};

PortraitsController.prototype = {
    init: function() {
        //scene controller
        var controller = new ScrollMagic();
        //scene option
        var option = {
            triggerElement: '#js-mainvisual',
            triggerHook: 'onLeave',
            //duration: '',
            offset: $('#js-portraits-header').height() + 150,
            reverse: true
        };

        var scene = this.getScrollScene(controller, option);
        require('../module/scene-globalHeader')(scene);

        //infiniteScroll
        var infiniteScroll = new this.InfiniteScroll();
        var $window = $(window);
        var trigger;

        var scrollHandler = function(){
            if(trigger){
                clearTimeout(trigger);
            }
            trigger = setTimeout(function(){
                if(infiniteScroll.checkPosition()){
                    infiniteScroll.load();
                }
            }, 200);
        }
        var resizeHandler = function(){
            infiniteScroll.resize();
        }
        var loadHandler = function(){
            infiniteScroll.set($('.js-infinite-scroll'));
            $window.on('scroll', scrollHandler);
            $window.on('resize', resizeHandler);
        }
        $window.on('load', loadHandler);
    }
};

module.exports = PortraitsController;



/** WEBPACK FOOTER **
 ** ./src/pc/assets/js/controller/PortraitsController.js
 **/